import React from 'react';
import SpanningWarningComponent from './SpanningWarningComponent';

function NoMatch(){
  return <SpanningWarningComponent message="404 Page Not Found" />
}

export default NoMatch;